// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-form-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: none;
    overflow :auto;
    height: 80vh;
    width: 90vw;
}

.event-form-container.active {
  display: block;
}


@media (max-width: 1500px) {
  .event-form-container{
      height: 20vh;
      width: 45vw;
  }
}


@media (max-width: 1024px) {
  .event-form-container{
      height: 50vh;
      width: 70vw;
  }
}

@media (max-width: 900px) {
  .event-form-container{
    width: 60vw;
    height: 30vh;
  }
}

@media (max-width: 500px) {
  .event-form-container{
      height: 10vh;
      width: 90vw;
  }
}



.add-event-button{
  padding: 10px 20px;
  background-color: #007bff;
  border: none;
  border-radius: 1em;
  color: white;
  margin: 0.25em;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease, colour 0.3s ease;
}

.add-event-button:hover{
    background-color: rgb(58, 98, 182);
}


#event-description{
  resize: vertical;
  font-family:Arial, Helvetica, sans-serif;
}


input[type=file]{
  margin:10px;
}


input[type=date], input[type=time]{
  width:95%;
}


#description-help{
  color: rgb(97, 95, 95);
}


.error-message, #event-error{
  color:rgb(208, 15, 15);
  padding-bottom: 4px;
}

#event-error{
  text-align:center;
}

.error-message{
  margin-right:20px;
  text-align: center;
}


.event-media-input{
  display:grid;
  grid-template-columns: auto auto;
  /* justify-content: space-around; */
  align-items: center;
}

.upload-file{
  background-color: #007bff;
  border: none;
  border-radius: 1em;
  color: white;
  margin: 0.25em;
  padding:5px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease, colour 0.3s ease;
  display:inline-block;
  text-align:center;
}

.upload-file:hover{
  background-color: #0056b3;
}


.event-form-header{
  display:flex;
  justify-content: space-between;
  vertical-align: middle;
}


.form-input {
  border-radius: 10px !important;
  border-color:  #007bff !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/addEvent.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;IACb,2CAA2C;IAC3C,aAAa;IACb,aAAa;IACb,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE;MACI,YAAY;MACZ,WAAW;EACf;AACF;;;AAGA;EACE;MACI,YAAY;MACZ,WAAW;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;MACI,YAAY;MACZ,WAAW;EACf;AACF;;;;AAIA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,wDAAwD;AAC1D;;AAEA;IACI,kCAAkC;AACtC;;;AAGA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;;AAGA;EACE,WAAW;AACb;;;AAGA;EACE,SAAS;AACX;;;AAGA;EACE,sBAAsB;AACxB;;;AAGA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,YAAY;EACZ,gCAAgC;EAChC,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,eAAe;EACf,eAAe;EACf,wDAAwD;EACxD,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;AACxB;;;AAGA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC","sourcesContent":[".event-form-container {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    padding: 20px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n    display: none;\n    overflow :auto;\n    height: 80vh;\n    width: 90vw;\n}\n\n.event-form-container.active {\n  display: block;\n}\n\n\n@media (max-width: 1500px) {\n  .event-form-container{\n      height: 20vh;\n      width: 45vw;\n  }\n}\n\n\n@media (max-width: 1024px) {\n  .event-form-container{\n      height: 50vh;\n      width: 70vw;\n  }\n}\n\n@media (max-width: 900px) {\n  .event-form-container{\n    width: 60vw;\n    height: 30vh;\n  }\n}\n\n@media (max-width: 500px) {\n  .event-form-container{\n      height: 10vh;\n      width: 90vw;\n  }\n}\n\n\n\n.add-event-button{\n  padding: 10px 20px;\n  background-color: #007bff;\n  border: none;\n  border-radius: 1em;\n  color: white;\n  margin: 0.25em;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, colour 0.3s ease;\n}\n\n.add-event-button:hover{\n    background-color: rgb(58, 98, 182);\n}\n\n\n#event-description{\n  resize: vertical;\n  font-family:Arial, Helvetica, sans-serif;\n}\n\n\ninput[type=file]{\n  margin:10px;\n}\n\n\ninput[type=date], input[type=time]{\n  width:95%;\n}\n\n\n#description-help{\n  color: rgb(97, 95, 95);\n}\n\n\n.error-message, #event-error{\n  color:rgb(208, 15, 15);\n  padding-bottom: 4px;\n}\n\n#event-error{\n  text-align:center;\n}\n\n.error-message{\n  margin-right:20px;\n  text-align: center;\n}\n\n\n.event-media-input{\n  display:grid;\n  grid-template-columns: auto auto;\n  /* justify-content: space-around; */\n  align-items: center;\n}\n\n.upload-file{\n  background-color: #007bff;\n  border: none;\n  border-radius: 1em;\n  color: white;\n  margin: 0.25em;\n  padding:5px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, colour 0.3s ease;\n  display:inline-block;\n  text-align:center;\n}\n\n.upload-file:hover{\n  background-color: #0056b3;\n}\n\n\n.event-form-header{\n  display:flex;\n  justify-content: space-between;\n  vertical-align: middle;\n}\n\n\n.form-input {\n  border-radius: 10px !important;\n  border-color:  #007bff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
